"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledReactModal = exports.StyledModalTitle = exports.StyledModalLoading = exports.StyledModalHeader = exports.StyledModalContent = exports.StyledModalBody = exports.StyledCloseButton = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _Modal = _interopRequireDefault(require("./Modal.adapter"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

var interpretDimension = function interpretDimension(dim) {
  return /^[0-9]+$/.test(dim) ? "".concat(dim, "px") : dim;
};

var _default = {};
exports["default"] = _default;
var StyledReactModal = (0, _styledComponents["default"])(_Modal["default"]).attrs({
  overlayClassName: 'Overlay',
  modalClassName: 'Modal'
}).withConfig({
  displayName: "Modalstyles__StyledReactModal",
  componentId: "sc-15udpbj-0"
})(["& .Overlay{", " background:", ";transition:height 0.5s ease-in-out,opacity 0.5s ease-in-out,width 0.5s ease-in-out;opacity:0;&[class*='--after-open']{opacity:1;}&[class*='--before-close']{opacity:0;}}& .Modal{", " transition:height 0.5s ease-in-out,opacity 0.5s ease-in-out,width 0.5s ease-in-out;box-shadow:", ";background-color:", ";color:", ";box-sizing:border-box;max-height:calc(100vh - 2rem);max-width:calc(100vw - 2rem);width:", ";", " opacity:0;&[class*='--after-open']{opacity:1;}&[class*='--before-close']{opacity:0;}}"], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["flex items-center justify-center fixed top-0 left-0 right-0 bottom-0 z-9999"]))), function (_ref) {
  var modal = _ref.theme.modal;
  return modal.overlayColorRgba;
}, (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n      flex bg-white flex-column ma0 outline-0 overflow-hidden relative sans-serif\n      ", "\n    "])), function (_ref2) {
  var modal = _ref2.theme.modal;
  return modal.borderRadius;
}), function (_ref3) {
  var modal = _ref3.theme.modal;
  return modal.boxShadowCss;
}, function (_ref4) {
  var _modal$backgroundColo;

  var modal = _ref4.theme.modal;
  return (_modal$backgroundColo = modal === null || modal === void 0 ? void 0 : modal.backgroundColor) !== null && _modal$backgroundColo !== void 0 ? _modal$backgroundColo : 'var(--white)';
}, function (_ref5) {
  var _modal$color;

  var modal = _ref5.theme.modal;
  return (_modal$color = modal === null || modal === void 0 ? void 0 : modal.color) !== null && _modal$color !== void 0 ? _modal$color : 'inherit';
}, function (_ref6) {
  var width = _ref6.width;
  return interpretDimension(width);
}, function (_ref7) {
  var height = _ref7.height,
      hasVariableHeight = _ref7.hasVariableHeight;
  return !hasVariableHeight && "height:  ".concat(interpretDimension(height), ";");
});
exports.StyledReactModal = StyledReactModal;

var StyledCloseButton = _styledComponents["default"].button.withConfig({
  displayName: "Modalstyles__StyledCloseButton",
  componentId: "sc-15udpbj-1"
})(["", ""], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    bn br-100 bg-transparent f3 flex items-center pa0 ma0 pointer\n    ", "\n  "])), function (_ref8) {
  var modal = _ref8.theme.modal;
  return modal.closeButton;
}));

exports.StyledCloseButton = StyledCloseButton;

var StyledModalBody = _styledComponents["default"].div.withConfig({
  displayName: "Modalstyles__StyledModalBody",
  componentId: "sc-15udpbj-2"
})(["", " ", ""], (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n    flex-auto h-100 relative overflow-y-auto\n    ", "\n  "])), function (_ref9) {
  var _theme$modal;

  var theme = _ref9.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$modal = theme.modal) === null || _theme$modal === void 0 ? void 0 : _theme$modal.body;
}), function (_ref10) {
  var _theme$modal2;

  var theme = _ref10.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$modal2 = theme.modal) === null || _theme$modal2 === void 0 ? void 0 : _theme$modal2.overrides;
});

exports.StyledModalBody = StyledModalBody;

var StyledModalContent = _styledComponents["default"].div.withConfig({
  displayName: "Modalstyles__StyledModalContent",
  componentId: "sc-15udpbj-3"
})(["", " box-sizing:border-box;& footer{", " ", "}& > div{", " & .gcc-app{", "}}"], (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n    flex flex-auto flex-wrap h-100 relative justify-between\n    ", "\n    ", "\n  "])), function (_ref11) {
  var _theme$modal3, _theme$modal3$content;

  var theme = _ref11.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$modal3 = theme.modal) === null || _theme$modal3 === void 0 ? void 0 : (_theme$modal3$content = _theme$modal3.content) === null || _theme$modal3$content === void 0 ? void 0 : _theme$modal3$content.appearance;
}, function (_ref12) {
  var _theme$modal4, _theme$modal4$content;

  var hasTitle = _ref12.hasTitle,
      theme = _ref12.theme;
  return hasTitle && (theme === null || theme === void 0 ? void 0 : (_theme$modal4 = theme.modal) === null || _theme$modal4 === void 0 ? void 0 : (_theme$modal4$content = _theme$modal4.content) === null || _theme$modal4$content === void 0 ? void 0 : _theme$modal4$content.withTitle);
}), function (_ref13) {
  var footerEnabled = _ref13.footerEnabled;
  return !footerEnabled && 'display: none;';
}, function (_ref14) {
  var footerEnabled = _ref14.footerEnabled;
  return footerEnabled && (0, _ty["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (_ref15) {
    var _theme$modal5, _theme$modal5$footer;

    var theme = _ref15.theme;
    return theme === null || theme === void 0 ? void 0 : (_theme$modal5 = theme.modal) === null || _theme$modal5 === void 0 ? void 0 : (_theme$modal5$footer = _theme$modal5.footer) === null || _theme$modal5$footer === void 0 ? void 0 : _theme$modal5$footer.appearance;
  });
}, (0, _ty["default"])(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["w-100"]))), (0, _ty["default"])(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["w-100 h-100"]))));

exports.StyledModalContent = StyledModalContent;

var StyledModalHeader = _styledComponents["default"].header.withConfig({
  displayName: "Modalstyles__StyledModalHeader",
  componentId: "sc-15udpbj-4"
})(["", ""], (0, _ty["default"])(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n    flex items-center justify-end flex-shrink-0 overflow-hidden\n    ", "\n    ", "\n  "])), function (_ref16) {
  var _theme$modal6, _theme$modal6$header;

  var theme = _ref16.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$modal6 = theme.modal) === null || _theme$modal6 === void 0 ? void 0 : (_theme$modal6$header = _theme$modal6.header) === null || _theme$modal6$header === void 0 ? void 0 : _theme$modal6$header.appearance;
}, function (_ref17) {
  var _theme$modal7, _theme$modal7$header;

  var hasTitle = _ref17.hasTitle,
      theme = _ref17.theme;
  return hasTitle && (theme === null || theme === void 0 ? void 0 : (_theme$modal7 = theme.modal) === null || _theme$modal7 === void 0 ? void 0 : (_theme$modal7$header = _theme$modal7.header) === null || _theme$modal7$header === void 0 ? void 0 : _theme$modal7$header.withTitle);
}));

exports.StyledModalHeader = StyledModalHeader;

var StyledModalLoading = _styledComponents["default"].div.withConfig({
  displayName: "Modalstyles__StyledModalLoading",
  componentId: "sc-15udpbj-5"
})(["", " pointer-events:none;& > div{", "}"], (0, _ty["default"])(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n    w-100 absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center\n  "]))), (0, _ty["default"])(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["w3 h3"]))));

exports.StyledModalLoading = StyledModalLoading;

var StyledModalTitle = _styledComponents["default"].h2.withConfig({
  displayName: "Modalstyles__StyledModalTitle",
  componentId: "sc-15udpbj-6"
})(["", ""], (0, _ty["default"])(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n    pr2 flex items-start items-center-ns mv0 w-100\n    ", "\n  "])), function (_ref18) {
  var _theme$modal8;

  var theme = _ref18.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$modal8 = theme.modal) === null || _theme$modal8 === void 0 ? void 0 : _theme$modal8.title;
}));

exports.StyledModalTitle = StyledModalTitle;